// extracted by mini-css-extract-plugin
export default {"staffSlipForm":"staffSlipForm---U_T5J"};